import { render, staticRenderFns } from "./CommentPopover.vue?vue&type=template&id=c03c6a10&scoped=true&"
import script from "./CommentPopover.vue?vue&type=script&lang=js&"
export * from "./CommentPopover.vue?vue&type=script&lang=js&"
import style0 from "./CommentPopover.vue?vue&type=style&index=0&id=c03c6a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03c6a10",
  null
  
)

export default component.exports